var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer-background py-4 mt-5" }, [
    _vm.footerLogoSrc
      ? _c("img", {
          staticClass: "mx-auto mt-3 mb-4 d-block",
          attrs: {
            alt: _vm.footerLogoAlt,
            height: _vm.footerLogoHeight,
            src: _vm.footerLogoSrc,
            width: _vm.footerLogoWidth
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "d-lg-flex justify-content-center text-center text-secondary"
      },
      [
        _c("div", { staticClass: "font-weight-bold pr-4 py-1" }, [
          _vm._v("\n      " + _vm._s(_vm.phoneNumber) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "working-hours" }, [
          _c("span", { staticClass: "working-hours__text py-1" }, [
            _vm._v(_vm._s(_vm.footerWorkingHours.weekdays))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "px-3 working-hours__separator" }, [
            _vm._v("-")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "working-hours__text py-1" }, [
            _vm._v(" " + _vm._s(_vm.footerWorkingHours.weekends))
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "text-center" }, [
      _c(
        "div",
        { staticClass: "text-secondary footer-links my-sm-3 my-md-1" },
        _vm._l(_vm.footerLinks, function(footerLink, index) {
          return _c("FooterLink", {
            key: "footer-link-" + index,
            attrs: { "footer-link": footerLink }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "copyright-text" }, [
        _vm._v("\n      © The Savings Group, Inc. All Rights Reserved.\n    ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }